<template>
    <VJoyWrapper class="prompt-entity-indicator" align="center" column-gap="4" row-gap="2" no-margin data-testid="prompt-entity-indicator">
        <VJoyPasswordRequirement
            v-for="entity in RECOGNIZED_PROMPT_ENTITY_KEYS"
            :key="entity"
            :label="$t(`search.advanced.ai.entrypoint.prompt.requirements.${entity}`)"
            :status="(detectedEntities ?? DEFAULT_RECOGNIZED_PROMPT_ENTITIES)[entity] ? 'success' : 'neutral'"
            :data-testid="`prompt-entity-${entity}`"
        />
    </VJoyWrapper>
</template>

<script setup lang="ts">
    import {VJoyPasswordRequirement, VJoyWrapper} from '@maltjoy/core-vue';
    import {
        DEFAULT_RECOGNIZED_PROMPT_ENTITIES,
        RECOGNIZED_PROMPT_ENTITY_KEYS,
        type RecognizedPromptEntities,
    } from '../../composables/usePromptEntities';

    defineProps<{
        detectedEntities: RecognizedPromptEntities | null;
    }>();
</script>

<style lang="scss" scoped>
    .prompt-entity-indicator {
        margin-top: var(--joy-core-spacing-4);
        padding: 0 var(--joy-core-spacing-6);
    }
</style>
